import React from 'react';

function Footer() {
    return(
        <footer class="footer gray-bg">
            <div class="copyright-section">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="copytext">&copy; Uday Kumar. All rights reserved | Developed By <a
                                    href="#">Me</a></div>
                        </div>
                    </div>
                    {/* <!--.row--> */}
                </div>
                {/* <!-- .container-fluid --> */}
            </div>
            {/* <!-- .copyright-section --> */}
        </footer>
        // <!-- .footer -->
    )
}

export default Footer;